/* eslint-disable import/no-cycle */
import Vue from 'vue';
import Api from '@/api';
/* eslint-enable import/no-cycle */
import Util from '@/util';

// eslint-disable-next-line no-unused-vars
const ALL_SYSTEMS = {
    SAP: 'sap',
    C1: 'celeraone',
    EVALANCHE: 'evalanche',
    SALESFORCE: 'salesforce',
};

const theState = {
    step: 1,
    loading: true,
    loadingSystems: false,
    storeId: '',
    ssoId: '',
    systems: [],
    email: '',
    checkedEmail: '',
    masterdata: {
        title: '',
        first_name: '',
        last_name: '',
        company: '',
        gender: '',
        email: '',
        login: '',
        user_id: '',
    },
};

const getters = {
    salutation(state) {
        return Util.mapC1GenderToSalutation(state.masterdata.gender);
    },
    hasError(state) {
        return state.errorMessage.length > 0;
    },
    hasInfo(state) {
        return state.infoMessage.length > 0;
    },
    fullname(state) {
        return Util.masterdataToFullName(state.masterdata);
    },
};

const actions = {
    initState({ commit }, ssoId) {
        commit('setSsoId', ssoId);
        if (ssoId) {
            commit('setLoading', true);
            Api.customer.getMasterdata(ssoId)
                .then((masterdata) => {
                    commit('setMasterdata', masterdata.data);
                    commit('setEmail', '');
                })
                .catch(() => {
                    commit('resetMasterdata');
                    commit('snackbar/error', 'Es ist ein Fehler aufgetreten.', { root: true });
                })
                .finally(() => commit('setLoading', false));
        }
    },
    checkEmail({ commit, state }) {
        commit('setLoadingSystems', true);
        Api.customer.checkCustomerEmail(state.ssoId, state.checkedEmail)
            .then((data) => {
                const systems = data.data.data.map(item => ({
                    email: item.email,
                    selected: item.preselection,
                    id: item.id,
                    system: item.system,
                    scope: item.scope,
                    updateable: item.updateable,
                    firstName: item.firstName,
                    lastName: item.lastName,
                }));

                commit('setSystems', systems);
                commit('setStep', 2);
            }).catch(() => {
                commit('snackbar/error', 'Es ist ein Fehler beim Überprüfen der E-Mail aufgetreten.', { root: true });
                commit('setStep', 1);
            }).finally(() => {
                commit('setLoadingSystems', false);
            });
    },

    changeEmail({ commit, state }) {
        commit('setLoading', true);
        let systems = {};

        state.systems.filter(s => s.selected).forEach((item) => {
            if (item.system.toLowerCase() === ALL_SYSTEMS.C1) {
                systems = {
                    ...systems,
                    celeraone: {
                        update: true,
                    },
                };
            } else if (item.system.toLowerCase() === ALL_SYSTEMS.EVALANCHE) {
                systems = {
                    ...systems,
                    evalanche: {
                        update: true,
                        storeId: item.id === null ? state.storeId : '',
                    },
                };
            } else if (item.system.toLowerCase() === ALL_SYSTEMS.SALESFORCE) {
                systems = {
                    ...systems,
                    salesforce: {
                        update: true,
                    },
                };
            } else if (item.system.toLowerCase() === ALL_SYSTEMS.SAP) {
                if (systems.sap) {
                    systems.sap.customerIds.push({
                        id: item.id,
                        scope: item.scope,
                    });
                } else {
                    systems = {
                        ...systems,
                        sap: {
                            customerIds: [
                                {
                                    id: item.id,
                                    scope: item.scope,
                                },
                            ],
                        },
                    };
                }
            }
        });

        const data = {
            email: state.checkedEmail,
            systems,
        };

        return new Promise((resolve, reject) => {
            Api.customer.updateCustomerEmail(state.ssoId, data).then(() => {
                commit('snackbar/success', 'Die Emailadresse wurde erfolgreich geändert.', { root: true });
                resolve();
            }).catch((response) => {
                commit('snackbar/error', `Beim Speichern der Emailadresse ist ein Fehler aufgetreten. (${response.data.message || 'Unbekannter Fehler'})`, { root: true });
                reject();
            }).finally(() => {
                commit('setLoading', true);
            });
        });
    },

    resetState({ commit }) {
        commit('setLoading', true);
        commit('setEmail', '');
        commit('setCheckedEmail', '');
        commit('setStep', 1);
        commit('setSsoId', '');
        commit('setSystems', []);
        commit('setStore', '');
        commit('setNeedStore', false);
        commit('resetMasterdata');
    },
};

const mutations = {
    setLoading(state, loading) {
        state.loading = loading;
    },

    setLoadingSystems(state, loading) {
        state.loadingSystems = loading;
    },

    setEmail(state, email) {
        state.email = email;
    },

    setCheckedEmail(state, email) {
        state.checkedEmail = email;
    },

    setStep(state, step) {
        state.step = step;
    },

    setSystems(state, systems) {
        state.systems = systems;
    },

    setNeedStore(state, needStore) {
        state.needStore = needStore;
    },

    setStore(state, store) {
        state.storeId = store;
    },

    setSsoId(state, ssoId) {
        state.ssoId = ssoId;
    },

    setMasterdata(state, {
        title,
        first_name,
        last_name,
        company,
        gender,
        email,
        login,
        user_id,
    }) {
        state.masterdata = {
            title,
            first_name,
            last_name,
            company,
            gender,
            email,
            login,
            user_id,
        };
    },

    resetMasterdata(state) {
        Vue.set(state, 'masterdata', {
            title: '',
            firstname: '',
            lastname: '',
            company: '',
            gender: '',
            email: '',
            login: '',
            user_id: '',
        });
    },
};

export default {
    namespaced: true,
    state: theState,
    getters,
    actions,
    mutations,
};
